// extracted by mini-css-extract-plugin
export var attribution = "_ax-4";
export var authorName = "_ax-5";
export var quote = "_ax-3";
export var testimonial = "_ax-2";
export var trustedBy = "_ax-0";
export var trustedByLabel = "_ax-1";